import { Injectable } from '@angular/core';
import { LocalStorageService } from './localstorage.service';
import { LocationService } from './location.service';
import { GeoJsCountry } from '../models/geioJsCountry';
import { tap } from 'rxjs/operators';
import { Preferences } from '../models/preferences';
import { BehaviorSubject, Observable, forkJoin, of, timer, interval, Subscription, combineLatest } from 'rxjs';
import { isThisHour } from 'date-fns';
import { NameId } from '../models/name-id';
import { CountryRedirectService } from './country-redirect.service';
import { filter, distinctUntilChanged, take, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {
  
  preferences$: BehaviorSubject<Preferences> = new BehaviorSubject(null);
  detectedCountry: GeoJsCountry;
  preferences: Preferences;
  needsReloadInternal = false;
  reloadTimerSub: Subscription;
  unitSetChoices:NameId[]=[{ id:"Metric", name:"Metric"},{id:"Imperial",name:"Imperial}"}];
  countryCode$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  languageCode$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  termsAndConditions$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  unitsChoice$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  seedUnitsChoice$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private storage: LocalStorageService, 
    private location: LocationService,
    private countryRedirect: CountryRedirectService) {
    this.termsAndConditions = this.storage.retrieve("terms") || false;
    this.unitsChoice = this.storage.retrieve("unitsChoice") ||"L/Ha";
    this.seedUnitsChoice = this.storage.retrieve("seedUnitsChoice") ||"L/ton";
    this.languageCode = this.storage.retrieve("languageCode") || 'en';

      this.location.getCountry().pipe(take(1)).subscribe(detected => {
    this.countryCode = detected?.country ?? null; // setter lowercases it
  });

  // One-time redirect when both values are available (or we have fallbacks)
  combineLatest([
    this.languageCode$.pipe(startWith(this.languageCode$.value), filter(Boolean), distinctUntilChanged()),
    this.countryCode$.pipe(startWith(this.countryCode$.value),  filter(Boolean), distinctUntilChanged()),
  ])
  .pipe(take(1))
  .subscribe(([lang, cc]) => {
    this.countryRedirect.redirectByLangOrCountry(lang, cc, { replace: true });
  });

    // var countryCode = this.storage.retrieve('countryCode');
    // if (countryCode == null) {
    //   this.location.getCountry().subscribe(detectedLocation => {
    //     console.log(detectedLocation);
    //     this.countryCode = detectedLocation.country
    //   });
    // }
    // else {

    //   this.countryCode = countryCode;
    // }

   
  //  this.countryCode$
  //   .pipe(filter(Boolean), distinctUntilChanged())
  //   .subscribe(cc => this.countryRedirect.redirectByLangOrCountry(this.languageCode$.value, cc));

  // this.languageCode$
  //   .pipe(filter(Boolean), distinctUntilChanged())
  //   .subscribe(lang => this.countryRedirect.redirectByLangOrCountry(lang, this.countryCode$.value));

  }
 
  get needsReload(): boolean {
    var val = this.needsReloadInternal;
    this.needsReloadInternal = false;
    return val;
  }
  set needsReload(value: boolean) {
    this.needsReloadInternal = value;
    this.reloadTimerSub = timer(800)
    .subscribe(x => {
      navigator.serviceWorker.getRegistrations()
      .then(
         registrations=> { 
          for(let registration of registrations) { 
            registration.unregister() ;
          } } ) 
         location.replace('/'+this.languageCode$.value+'/index.html');
     // location.reload()
        });
      
        
  }

  set termsAndConditions(terms: boolean) {
    if (terms != this.termsAndConditions$.value) {
      this.storage.store('terms', terms);
      this.termsAndConditions$.next(terms);
    }
  }
  set unitsChoice( unitsChoiceId:string) {
    if (unitsChoiceId != this.unitsChoice$.value) {
      this.storage.store('unitsChoice', unitsChoiceId);
      this.unitsChoice$.next(unitsChoiceId);
    }
  }

  set seedUnitsChoice( seedUnitsChoiceId:string) {
    if (seedUnitsChoiceId != this.seedUnitsChoice$.value) {
      this.storage.store('seedUnitsChoice', seedUnitsChoiceId);
      this.seedUnitsChoice$.next(seedUnitsChoiceId);
    }
  }

  set countryCode(code: string) {
    if (code != this.countryCode$.value) {
      //this.storage.store('countryCode', code);
      this.countryCode$.next(code?.toLowerCase?.() ?? null);
    }
  }

  set languageCode(code: string) {
    if (code != this.languageCode$.value) {

      document.cookie = "lang=" + code + "; expires=31 Dec 2100 23:59:59 GMT path=/";
      this.storage.store('languageCode', code);
      this.languageCode$.next(code);

    }
  }
  forceToAmerica() {
   if (this.languageCode$.value!='en' || this.countryCode$.value!='us'){
    this.needsReload=true;
    this.languageCode="en";
    this.countryCode="us";
   }
  }
  convertWaterUnits(inp:number):number{
    switch(this.unitsChoice$.value)
    {
      case "L/ha":return inp;
      case "US gal/ac":return inp*0.106906781;//0.264172/2.47105
      case "US pt/ac":return inp*0.855255863;//2.11338/2.47105
    }
    return inp;
  }
  convertApplicationUnits(inp:number):number{
    switch(this.unitsChoice$.value)
    {
      case "L/ha":return inp;
      case "US gal/ac":return inp*0.106906781;//   0.264172/2.47105
      case "US pt/ac":return inp*0.855255863; //   2.11338/2.47105
    }
    return inp;
  }
  convertSeedUnits(inp:number):number{
    switch(this.seedUnitsChoice$.value)
    {
      case "L/ton":return inp *1000;//metric ton  1/0.001
      case "US gal/US ton":return inp*239.6530921;// 0.264172/0.00110231
      case "US pt/US ton":return inp*1935.7531; //     2.11338/0.00110231
    }
    return inp;
  }
  convertPowderUnits(inp:number):string{
    switch(this.unitsChoice$.value)
    {
    
      case "US gal/ac":
      case "US pt/ac":return  (inp*0.892171344).toFixed(2)+  " US lb/ac";//2.2046/2.47105
      default:
        return  (inp).toFixed(2)+ " kg/ha";
    }
    
  }

}
